import { AxiosHeaders, type AxiosInstance } from "axios";

export const useApiKeyInterceptor = (instance: AxiosInstance) => {
	instance.interceptors.request.use((req) => {
		const xApiKey = localStorage.getItem("apiKey"); // @TODO: get from pinia?

		if (!req.headers) req.headers = new AxiosHeaders();
		if (xApiKey) req.headers["x-api-key"] = xApiKey;

		return req;
	});
};
